export const FRAME_PAGE_ROUTE = 'framePage';
export const WORKSPACES_PAGE_ROUTE = 'workspaces';
export const MAP_PAGE_ROUTE = '';
export const MAP_WIDGET_ROUTE = 'map-widget';
export const IFRAME_WIDGET_ROUTE = 'iframe-widget';
export const ALARM_SUMMARY_WIDGET_ROUTE = 'alarm-summary-widget';
export const INTEGRATIONS_PAGE_ROUTE = 'integrations';
export const ACCOUNT_SETTINGS_PAGE_ROUTE = 'account';
export const SYSTEM_SETTINGS_PAGE_ROUTE = 'system';
export const SOURCES_PAGE_ROUTE = 'sources';
export const WEATHER_PAGE_ROUTE = 'weather';
export const TOLLING_PAGE_ROUTE = 'tolling';
export const TUNNELS_PAGE_ROUTE = 'tunnels';
export const CORRIDORS_PAGE_ROUTE = 'corridors';
export const SIGNS_PAGE_ROUTE = 'signs';
export const VIDEO_PAGE_ROUTE = 'video';
export const EVENTS_PAGE_ROUTE = 'events';
export const LOCATION_PAGE_ROUTE = 'location';
export const LOCATIONS_PAGE_ROUTE = 'locations';
export const DETECTORS_PAGE_ROUTE = 'counts';
export const TRANSIT_PAGE_ROUTE = 'transit';
export const TRAVEL_TIME_PAGE_ROUTE = 'travel-time';
export const SIGNALS_PAGE_ROUTE = 'signals';
export const CONNECTED_VEHICLES_PAGE_ROUTE = 'connectedvehicles';
export const RAMP_METER_PAGE_ROUTE = 'ramp-meter';
export const ROAD_ASSISTANCE_PAGE_ROUTE = 'roadassistance';
export const GATES_PAGE_ROUTE = 'gates';
export const HAR_PAGE_ROUTE = 'har';
export const CONTACTS_PAGE_ROUTE = 'contacts';
export const EMAILS_PAGE_ROUTE = 'emails';
export const COMMUNICATION_LOGS_PAGE_ROUTE = 'communicationlogs';
export const FLEET_PAGE_ROUTE = 'fleet';
export const PARKING_PAGE_ROUTE = 'parking';
export const ROUTE_DELETE_REGEX = `delete`;
export const ROUTE_CLOSE_REGEX = `close`;
export const FILE_MANAGER_PAGE_ROUTE = `filemanager`;
export const SITES_PAGE_ROUTE = 'counts/site';
export const REPORT_BUILDER_PAGE_ROUTE = 'report-builder';
export const LOCATIONS_MODULE_ROUTE = 'locations';

export const LOCATIONS_DETAILS_ROUTE = LOCATIONS_MODULE_ROUTE;
export const LOCATIONS_TEMPLATES_ROUTE = `${LOCATIONS_MODULE_ROUTE}/templates`;
export const LOCATIONS_EDIT_PAGE_ROUTE = `${LOCATIONS_DETAILS_ROUTE}/edit`;

export const ROAD_CONDITIONS_PAGE_ROUTE = 'road-conditions';
export const ROUTE_FULL_UUID_REGEX =
  '^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$';

export const enumRoute = (enumObject: Record<string, string>) => {
  return `(${Object.values(enumObject).join('|')})`;
};

export * from './asset-management';

export * from './video';
